import {ActionbarItem, IconType} from '@catcore/types/base';

const stateStoreFeatureId = 'projectDetails';

export const Actions: ActionbarItem[] = [
  {
    iconType: IconType.Symbol,
    iconSrc: 'icon-properties',
    label: 'Properties',
    routeTarget: (projectId): string[] => ['projects', `${projectId}`, 'properties'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'properties',
    },
  },
  {
    iconType: IconType.Symbol,
    iconSrc: 'icon-feature-types',
    label: 'Features',
    routeTarget: (projectId): string[] => ['projects', `${projectId}`, 'features'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'projectFeatures',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'SBD',
    label: 'System Block Diagram',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'sbd'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'sbd',
    },

  },
  {
    iconType: IconType.Text,
    iconSrc: 'GUI',
    label: 'GUI Zones',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'gui-zones'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'guiZones',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'GEN',
    label: 'Packages Generation',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'packages-generation'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'userdata',
    },
    isApplicableForProject: (project) => {
      console.log("Check applicability for project: ", project);
      return project._links.hasOwnProperty("program")
        && project._links.program.label === 'Global 7500';
    }
  },
  {
    iconType: IconType.Text,
    iconSrc: 'UPL',
    label: 'Uploaded Files',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'upload-files'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'uploadFiles',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'OPT',
    label: 'Options',
    routeTarget: (projectId): string[] => ['projects', `${projectId}`, 'tokens'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'tokens',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'PTR',
    label: 'Parameter Search',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'parameters'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'parameters',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'SPK',
    label: 'Speaker Setup',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'speaker-setup'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'speakerSetup',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'A/V',
    label: 'AVoD',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'avod'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'avod',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'VID',
    label: 'EVID',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'evid'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'evid',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'GGW',
    label: 'GUI Gateway',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'ggw'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'ggw',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'P/N',
    label: 'Part Numbers',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'partnumbers'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'pn',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'CHK',
    label: 'Config Checklist',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'checklist'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'checklist',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'CFG',
    label: 'Generated Config Files',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'service-files'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'psf',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'TST',
    label: 'Test Rack',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'test-rack'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'testRack',
    },
  },
  {
    iconType: IconType.Text,
    iconSrc: 'ICON',
    label: 'LOPA Icon Positions',
    routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'lopa-positions'],
    isActive: false,
    reactToState: {
      feature: stateStoreFeatureId,
      property: 'lopa-positions',
    },
  },


  // {
  //   iconType: IconType.Text,
  //   iconSrc: 'GZ',
  //   label: 'GUI Zones',
  //   routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'gui-zones'],
  //   isActive: false,
  //   reactToState: {
  //     feature: featureId,
  //     property: 'guiZones',
  //   },
  //
  // },
  // {
  //   iconType: IconType.Text,
  //   iconSrc: 'SBD',
  //   label: 'SBD',
  //   routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'sbd'],
  //   isActive: false,
  //   reactToState: {
  //     feature: featureId,
  //     property: 'sbd',
  //   },
  //
  // },
  // {
  //   iconType: IconType.Text,
  //   iconSrc: 'GUI',
  //   label: 'GUI Control Matrix',
  //   routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'control-matrix'],
  //   isActive: false,
  //   reactToState: {
  //     feature: featureId,
  //     property: 'guiControlMatrix',
  //   },
  //
  // },
  // {
  //   iconType: IconType.Text,
  //   iconSrc: 'IO',
  //   label: 'IO Control Matrix',
  //   routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'io-control-matrix'],
  //   isActive: false,
  //   reactToState: {
  //     feature: featureId,
  //     property: 'ioControlMatrix',
  //   },
  //
  // },
  // {
  //   iconType: IconType.Text,
  //   iconSrc: 'AV',
  //   label: 'AV Matrix',
  //   routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'av-matrix'],
  //   isActive: false,
  //   reactToState: {
  //     feature: featureId,
  //     property: 'avMatrix',
  //   },
  //
  // },
  // {
  //   iconType: IconType.Text,
  //   iconSrc: 'V1',
  //   label: 'API V1 Section',
  //   routeTarget: (projectId): string[]  => ['projects', `${projectId}`, 'api-v1'],
  //   isActive: false,
  //   reactToState: {
  //     feature: stateStoreFeatureId,
  //     property: 'api-v1',
  //   },
  //
  // },
];



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project/actionbar-items.ts